import * as R from 'ramda';

export const orCreate = R.defaultTo('create');
